export default __webpack_public_path__ + "static/media/AOE4.0f4b9993.jpg";